import React from "react";

import { useAccountingApi } from "../api/accounting.api";

export const useTransactionDetails = (
  transactionId?: number,
) => {
  const [ transactionDetailsResponse, getTransactionDetailsApi ] = useAccountingApi("GET_TRANSACTION_DETAILS");

  const fetchTransaction = React.useCallback(() => {
    if (!transactionId) return;

    getTransactionDetailsApi(Number(transactionId));
  }, [ getTransactionDetailsApi, transactionId ]);

  React.useEffect(() => {
    fetchTransaction();
  }, [ fetchTransaction ]);

  return {
    transaction: transactionDetailsResponse.data || null,
    loading: transactionDetailsResponse.pending,
    error: transactionDetailsResponse.error,
    refetch: fetchTransaction
  };
};

export default useTransactionDetails;
